
import { Chord, ChordNoTt, Section } from './backingTrackGeneratorEditorState'

export enum EditorActionType {
	Play,
	Progress,
	Complete,
	Stop,

	// Cursor

	CursorMovePrevBar,
	CursorMoveNextBar,
	CursorMovePrevBeat,
	CursorMoveNextBeat,
	CursorMovePrev16th,
	CursorMoveNext16th,
	
	CursorExpandLeftBar,
	CursorExpandRightBar,
	CursorExpandLeftBeat,
	CursorExpandRightBeat,
	CursorExpandLeft16th,
	CursorExpandRight16th,

	CursorUnselect,
	CursorDelete,
	CursorToChordSelect,

	CursorMove,
	CursorDragStart,
	CursorDrag,
	CursorDragEnd,

	// Chord

	ChordSelectMovePrevBar,
	ChordSelectMoveNextBar,
	ChordSelectMovePrevBeat,
	ChordSelectMoveNextBeat,
	ChordSelectMovePrev16th,
	ChordSelectMoveNext16th,

	ChordSelect,
	ChordUnselect,
	ChordSelectPrev,
	ChordSelectNext,
	ChordSelectExpandLeft,
	ChordSelectExpandRight,
	ChordSelectDelete,

	ChordSelectSection,
	ChordSelectGroup,

	ChordSelectDragStart,
	ChordSelectDrag,
	// ChordSelectDragChangeLine,
	ChordSelectDragEnd,

	Import,
	ChordChange,
	ChordTabPressed,
	ChordBlur,
	ChordFocus,

	ChordAdd,
	ChordDegreeUp,
	ChordDegreeDown,

	// Controls

	CurrAddChordTtdChange,

	// Suggestions

	ProgressionAdd,
}

// Play / Pause

export interface Play {
	type: EditorActionType.Play
}

export interface Progress {
	type: EditorActionType.Progress
	payload: {
		transportTime: string
	}
}

export interface Complete {
	type: EditorActionType.Complete
}

export interface Stop {
	type: EditorActionType.Stop
}


// Cursor

export interface CursorMovePrevBar {
	type: EditorActionType.CursorMovePrevBar
}
export interface CursorMoveNextBar {
	type: EditorActionType.CursorMoveNextBar,
}

export interface CursorMovePrevBeat {
	type: EditorActionType.CursorMovePrevBeat
}
export interface CursorMoveNextBeat {
	type: EditorActionType.CursorMoveNextBeat,
}

export interface CursorMovePrev16th {
	type: EditorActionType.CursorMovePrev16th
}
export interface CursorMoveNext16th {
	type: EditorActionType.CursorMoveNext16th,
}


export interface CursorExpandLeftBar {
	type: EditorActionType.CursorExpandLeftBar
}
export interface CursorExpandRightBar {
	type: EditorActionType.CursorExpandRightBar,
}

export interface CursorExpandLeftBeat {
	type: EditorActionType.CursorExpandLeftBeat
}
export interface CursorExpandRightBeat {
	type: EditorActionType.CursorExpandRightBeat,
}

export interface CursorExpandLeft16th {
	type: EditorActionType.CursorExpandLeft16th
}
export interface CursorExpandRight16th {
	type: EditorActionType.CursorExpandRight16th,
}

export interface CursorUnselect {
	type: EditorActionType.CursorUnselect,
}

export interface CursorDelete {
	type: EditorActionType.CursorDelete,
}

export interface CursorToChordSelect {
	type: EditorActionType.CursorToChordSelect,
}


export interface CursorMove {
	type: EditorActionType.CursorMove,
	payload: {
		transportTime: string,
	}
}

export interface CursorDragStart {
	type: EditorActionType.CursorDragStart,
	payload: {
		transportTime: string,
	}
}
export interface CursorDrag {
	type: EditorActionType.CursorDrag,
	payload: {
		transportTime: string,
	}
}
export interface CursorDragEnd {
	type: EditorActionType.CursorDragEnd
}


// Chord


export interface ChordSelectMovePrevBar {
	type: EditorActionType.ChordSelectMovePrevBar
}
export interface ChordSelectMoveNextBar {
	type: EditorActionType.ChordSelectMoveNextBar
}

export interface ChordSelectMovePrevBeat {
	type: EditorActionType.ChordSelectMovePrevBeat
}
export interface ChordSelectMoveNextBeat {
	type: EditorActionType.ChordSelectMoveNextBeat
}

export interface ChordSelectMovePrev16th {
	type: EditorActionType.ChordSelectMovePrev16th
}
export interface ChordSelectMoveNext16th {
	type: EditorActionType.ChordSelectMoveNext16th
}

// Chord Drag

export interface ChordSelectDragStart {
	type: EditorActionType.ChordSelectDragStart,
	payload: {
		chordIndex: number,
		globalLineIndex: number,
		transportTime: string,
	}
}
export interface ChordSelectDrag {
	type: EditorActionType.ChordSelectDrag,
	payload: {
		transportTime: string,
		globalLineIndex: number,
	}
}
// export interface ChordSelectDragChangeLine {
// 	type: EditorActionType.ChordSelectDragChangeLine,
// 	payload: {
// 		globalLineIndex: number,
// 	}
// }
export interface ChordSelectDragEnd {
	type: EditorActionType.ChordSelectDragEnd
	payload: {
		transportTime: string,
	}
}

export interface ChordSelect {
	type: EditorActionType.ChordSelect,
	payload: {
		index: number
	}
}

export interface ChordUnselect {
	type: EditorActionType.ChordUnselect
}

export interface ChordSelectPrev {
	type: EditorActionType.ChordSelectPrev
}
export interface ChordSelectNext {
	type: EditorActionType.ChordSelectNext,
}

export interface ChordSelectExpandLeft {
	type: EditorActionType.ChordSelectExpandLeft
}
export interface ChordSelectExpandRight {
	type: EditorActionType.ChordSelectExpandRight,
}

export interface ChordSelectDelete {
	type: EditorActionType.ChordSelectDelete,
}

export interface ChordSelectGroup {
	type: EditorActionType.ChordSelectGroup,
}

// Others

export interface Import {
	type: EditorActionType.Import,
	payload: {
		sections: Section[]
	}
}

export interface ChordChange {
	type: EditorActionType.ChordChange,
	payload: {
		chord: Chord
	}
}

export interface ChordTabPressed {
	type: EditorActionType.ChordTabPressed,
	payload: {
		index: number
	}
}

export interface ChordBlur {
	type: EditorActionType.ChordBlur,
}
export interface ChordFocus {
	type: EditorActionType.ChordFocus,
	payload: {
		index: number
	}
}

export interface ChordAdd {
	type: EditorActionType.ChordAdd,
	payload: {
		chord: ChordNoTt
	}
}

export interface ProgressionAdd {
	type: EditorActionType.ProgressionAdd,
	payload: {
		chords: ChordNoTt[]
	}
}

export interface ChordDegreeUp {
	type: EditorActionType.ChordDegreeUp,
}
export interface ChordDegreeDown {
	type: EditorActionType.ChordDegreeDown,
}

// Controls

export interface CurrAddChordTtdChange {
	type: EditorActionType.CurrAddChordTtdChange,
	payload: {
		ttD: string
	}
}

export type EditorActions = Play | Progress | Complete | Stop |
	CursorMovePrevBar | CursorMoveNextBar | CursorMovePrevBeat | CursorMoveNextBeat | CursorMovePrev16th | CursorMoveNext16th |
	CursorExpandLeftBar | CursorExpandRightBar | CursorExpandLeftBeat | CursorExpandRightBeat | CursorExpandLeft16th | CursorExpandRight16th |
	CursorUnselect | CursorDelete | CursorToChordSelect |
	CursorMove |
	CursorDragStart | CursorDrag | CursorDragEnd |
	ChordSelectDragStart | ChordSelectDrag | ChordSelectDragEnd |
	ChordSelect | ChordUnselect | ChordSelectPrev | ChordSelectNext | ChordSelectExpandLeft | ChordSelectExpandRight |
	ChordSelectMovePrevBar | ChordSelectMoveNextBar | ChordSelectMovePrevBeat | ChordSelectMoveNextBeat | ChordSelectMovePrev16th | ChordSelectMoveNext16th |
	ChordSelectGroup |
	Import | ChordTabPressed | ChordBlur | ChordFocus | ChordChange | ChordSelectDelete |
	ChordAdd | ChordDegreeUp | ChordDegreeDown |
	CurrAddChordTtdChange |
	ProgressionAdd